// react
import React from "react";
import PropTypes from "prop-types";

import css from "./Textarea.styl";

export default class TextInput extends React.Component {
	static propTypes = {
		onKeyDown: PropTypes.func,
		onFocus: PropTypes.func,
		onBlur: PropTypes.func,
		onChange: PropTypes.func,
		className: PropTypes.string,
		name: PropTypes.string,
		type: PropTypes.string,
		value: PropTypes.string.isRequired,
		initialHeight: PropTypes.number,
	};

	static defaultProps = {
		name: "",
		className: "",
		type: "text",
		initialHeight: 100,
		onBlur: () => {},
		onFocus: () => {},
		onChange: () => {},
		onKeyDown: () => {},
	};

	constructor(props) {
		super(props);

		this.textInput = React.createRef();
		this.handleChange = this.handleChange.bind(this);
	}

	focus = () => {
		this.textInput.focus();
	};

	handleKeyDown = (event) => {
		this.props.onKeyDown(event);
	};

	handleFocus = () => {
		this.props.onFocus();
	};

	handleBlur = () => {
		this.props.onBlur();
	};

	handleChange = (event) => {
		this.props.onChange(event.target.value, this.props.name);
	};

	render = () => {
		return (
			<textarea
				style={{ height: this.props.initialHeight }}
				ref={this.textInput}
				type={this.props.type}
				name={this.props.name}
				value={this.props.value}
				onBlur={this.handleBlur}
				onFocus={this.handleFocus}
				onChange={this.handleChange}
				onKeyDown={this.handleKeyDown}
				className={`${css.textarea} ${this.props.className}`}
			/>
		);
	};
}
